<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button class="breadcrumb-back" @click="$router && $router.back ? $router.back() : window.history.back()">返回</button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.zhiwu }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.name }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">文字课件列表</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">文字课件详情</span>
        </div>

        <!-- 课件详情 -->
        <div class="courseware-detail">
          <div class="courseware-header">
            <h1 class="courseware-title">《{{ data.title || '--' }}》</h1>
            <div class="courseware-meta">
              <div class="meta-stats">
                <span class="meta-item"><img src="@/assets/images/eye.png" alt="阅读"> 阅读：<span class="count">{{ data.clickcount || 0 }}</span></span>
                <span class="meta-item"><img src="@/assets/images/ly.png" alt="留言"> 留言：<span class="count">{{ data.liuyancount || 0 }}</span></span>
                <span class="meta-item"><img src="@/assets/images/time.png" alt="时间"> {{ data.inputtime || '-' }}</span>
              </div>
              <div class="meta-actions">
                <button class="btn-edit">播报</button>
                <button class="btn-report">普通话</button>
              </div>
            </div>
          </div>
          <embed :src="picUrl + data.fileurl" width="800" height="600" />
          <div class="courseware-content">
            <div v-html="data.jianjie"></div>
          </div>

          <div class="courseware-image">
            <img v-if="data.fengmian" :src="data.fengmian" alt="课件封面图">
          </div>

          <div class="comment-section">
            <div class="comment-input">
              <textarea placeholder="请输入留言内容" class="comment-textarea" v-model="message"></textarea>
              <button class="btn-publish" @click="leaveMessage">发布</button>
            </div>

            <div class="comment-list">
              <div class="comment-item" v-for="(item, index) in travleList.lists" :key="index">
                <div class="avatar">
                  <img :src="picUrl + item.touxiang" alt="用户头像">
                </div>
                <div class="comment-content">
                  <div class="nickname">{{ item.nickname }}</div>
                  <div class="text">{{ item.content }}</div>
                  <div class="comment-time">
                    <img src="@/assets/images/time.png" alt="时间">
                    <span class="time">{{ item.inputtime }}</span>
                    <span class="reply" @click="openHfLiuyan(index, !indexes[index])">回复</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import sign from '@/auth/sign'
import url from '@/axios/url'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getKejianMessL, getKejianDetail, getPostMessage, getPostReplyM, getEduDetails } from '@/axios/education'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      page: 1,
      picUrl: url.picUrl,
      appid: 'wzwebapp',
      id: parseInt(this.$route.query.id),
      type: parseInt(this.$route.query.type) || 1, // 默认文字课件类型
      travleList: {},
      data: {},
      message: '',
      huifuMessage: '',
      indexes: [],
      teacherInfo: {
        name: '',
        zhiwu: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getData()
    this.getLists()
  },
  methods: {
    getLists () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        page: this.page,
        id: this.id
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getKejianMessL(oneParams).then(res => {
        if (res.data.msg === '请求成功') {
          this.travleList = res.data.data
          this.indexes = new Array(res.data.data.lists.length).fill(false)
        }
      })
    },
    getData () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        type: this.type
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      getKejianDetail(oneParams).then(res => {
        if (res.data.code === 202) {
          this.$message({ type: 'warning', message: '请先登录' })
        } else if (res.data.code === 201 || res.data.code === 401) {
          this.$message({ type: 'error', message: res.data.msg })
        } else if (res.data.code === 200) {
          this.data = res.data.data
          // 获取教师信息
          this.getTeacherInfo()
        }
      })
    },
    getTeacherInfo () {
      const params = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.data.teacher_id,
        type: 3
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = {
            name: data.realname || '',
            zhiwu: data.zhiwu || ''
          }
        }
      })
    },
    leaveMessage () {
      this.postMessage()
    },
    postMessage () {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        msg: this.message
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      const data = Qs.stringify(
        oneParams,
        {
          allowDots: true
        }
      )
      getPostMessage(data).then(res => {
        this.$message({ type: 'info', message: res.data.msg })
        this.message = ''
        this.getLists()
      })
    },
    postReplyM (messageId) {
      const oneParams = {
        appid: this.appid,
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.id,
        message_id: messageId,
        msg: this.huifuMessage
      }
      const signO = sign(oneParams)
      oneParams.sign = signO
      const data = Qs.stringify(
        oneParams,
        {
          allowDots: true
        }
      )
      getPostReplyM(data).then(res => {
        this.$message({ type: 'info', message: res.data.msg })
        this.huifuMessage = ''
        this.getLists()
      })
    },
    openHfLiuyan (index, flag) {
      this.$set(this.indexes, index, flag)
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    }
  }
}
</script>

<style scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
}
.breadcrumb-back:hover {
  background: #f2f2f2;
  border-color: #ccc;
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #EF8432;
  font-weight: bold;
}

/* 课件详情样式 */
.courseware-detail {
  background: #fff;
  border-radius: 6px;
}
.courseware-header {
  margin-bottom: 20px;
  background: url('../../assets/images/title-bg.png') no-repeat center center;
  background-size: cover;
  padding: 20px;
}
.courseware-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px;
  font-weight: normal;
}
.courseware-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.meta-stats {
  display: flex;
  color: #888;
  font-size: 14px;
}
.meta-item {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.meta-item:first-child .count {
  color: #4caf50;
}
.meta-item img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.meta-actions {
  display: flex;
}
.btn-edit, .btn-report {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  margin-left: 8px;
  cursor: pointer;
  border: none;
}
.btn-edit {
  background: #fff;
  color: #EF8432;
  border: 1px solid #EF8432;
}
.btn-report {
  background: #ff9800;
  color: #fff;
}

/* 内容区域样式 */
.courseware-content {
  margin-bottom: 20px;
}
.courseware-content h2 {
  font-size: 16px;
  margin: 0 0 15px;
  color: #333;
}
.step-list {
  margin: 0;
  color: #666;
  line-height: 1.8;
}
.step-list li {
  margin-bottom: 10px;
}

/* 图片区域 */
.courseware-image {
  margin: 20px 0;
  text-align: center;
}
.courseware-image img {
  max-width: 100%;
}

/* 评论区域 */
.comment-section {
  margin-top: 10px;
}
.comment-input {
  display: flex;
  margin-bottom: 20px;
  background: #F7F7F7;
  padding: 15px;
  border-radius: 4px;
}
.comment-textarea {
  flex: 1;
  height: 60px;
  border: none;
  border-radius: 4px;
  resize: none;
  font-size: 14px;
  background: #F7F7F7;
}
.btn-publish {
  width: 80px;
  margin-left: 10px;
  background: #EF8432;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  align-self: flex-end;
}
.comment-list {
  margin-top: 20px;
}
.comment-item {
  display: flex;
  margin-bottom: 20px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.comment-content {
  flex: 1;
}
.nickname {
  font-weight: bold;
  margin-bottom: 5px;
}
.text {
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
  background: #fdf2ea;
  padding: 10px;
  border-radius: 4px;
}
.comment-time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}
.comment-time img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.time {
  margin-right: 10px;
}
.reply {
  color: #EF8432;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/TextCoursewareDetail.vue